/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  InvalidateQueryFilters,
  QueryClient,
  useQuery,
  UseQueryResult,
  useSuspenseQuery,
  UseSuspenseQueryResult,
} from "@tanstack/react-query";
import { GramError } from "../models/errors/gramerror.js";
import {
  ConnectionError,
  InvalidRequestError,
  RequestAbortedError,
  RequestTimeoutError,
  UnexpectedClientError,
} from "../models/errors/httpclienterrors.js";
import { ResponseValidationError } from "../models/errors/responsevalidationerror.js";
import { SDKValidationError } from "../models/errors/sdkvalidationerror.js";
import { ServiceError } from "../models/errors/serviceerror.js";
import {
  ListMcpServersForOrgRequest,
  ListMcpServersForOrgSecurity,
} from "../models/operations/listmcpserversfororg.js";
import { useGramContext } from "./_context.js";
import {
  QueryHookOptions,
  SuspenseQueryHookOptions,
  TupleToPrefixes,
} from "./_types.js";
import {
  buildListMcpServersForOrgQuery,
  ListMcpServersForOrgQueryData,
  prefetchListMcpServersForOrg,
  queryKeyListMcpServersForOrg,
} from "./listMcpServersForOrg.core.js";
export {
  buildListMcpServersForOrgQuery,
  type ListMcpServersForOrgQueryData,
  prefetchListMcpServersForOrg,
  queryKeyListMcpServersForOrg,
};

export type ListMcpServersForOrgQueryError =
  | ServiceError
  | GramError
  | ResponseValidationError
  | ConnectionError
  | RequestAbortedError
  | RequestTimeoutError
  | InvalidRequestError
  | UnexpectedClientError
  | SDKValidationError;

/**
 * listMcpServersForOrg mcpServers
 *
 * @remarks
 * List all MCP servers across the organization
 */
export function useListMcpServersForOrg(
  request?: ListMcpServersForOrgRequest | undefined,
  security?: ListMcpServersForOrgSecurity | undefined,
  options?: QueryHookOptions<
    ListMcpServersForOrgQueryData,
    ListMcpServersForOrgQueryError
  >,
): UseQueryResult<
  ListMcpServersForOrgQueryData,
  ListMcpServersForOrgQueryError
> {
  const client = useGramContext();
  return useQuery({
    ...buildListMcpServersForOrgQuery(
      client,
      request,
      security,
      options,
    ),
    ...options,
  });
}

/**
 * listMcpServersForOrg mcpServers
 *
 * @remarks
 * List all MCP servers across the organization
 */
export function useListMcpServersForOrgSuspense(
  request?: ListMcpServersForOrgRequest | undefined,
  security?: ListMcpServersForOrgSecurity | undefined,
  options?: SuspenseQueryHookOptions<
    ListMcpServersForOrgQueryData,
    ListMcpServersForOrgQueryError
  >,
): UseSuspenseQueryResult<
  ListMcpServersForOrgQueryData,
  ListMcpServersForOrgQueryError
> {
  const client = useGramContext();
  return useSuspenseQuery({
    ...buildListMcpServersForOrgQuery(
      client,
      request,
      security,
      options,
    ),
    ...options,
  });
}

export function setListMcpServersForOrgData(
  client: QueryClient,
  queryKeyBase: [parameters: { gramSession?: string | undefined }],
  data: ListMcpServersForOrgQueryData,
): ListMcpServersForOrgQueryData | undefined {
  const key = queryKeyListMcpServersForOrg(...queryKeyBase);

  return client.setQueryData<ListMcpServersForOrgQueryData>(key, data);
}

export function invalidateListMcpServersForOrg(
  client: QueryClient,
  queryKeyBase: TupleToPrefixes<
    [parameters: { gramSession?: string | undefined }]
  >,
  filters?: Omit<InvalidateQueryFilters, "queryKey" | "predicate" | "exact">,
): Promise<void> {
  return client.invalidateQueries({
    ...filters,
    queryKey: ["@gram/client", "mcpServers", "listForOrg", ...queryKeyBase],
  });
}

export function invalidateAllListMcpServersForOrg(
  client: QueryClient,
  filters?: Omit<InvalidateQueryFilters, "queryKey" | "predicate" | "exact">,
): Promise<void> {
  return client.invalidateQueries({
    ...filters,
    queryKey: ["@gram/client", "mcpServers", "listForOrg"],
  });
}
